import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authAPI } from '../../utils/api';
import { Alert, Spinner } from '../../components/ui';
import toast from 'react-hot-toast';

export default function Login() {
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [pendingMsg, setPendingMsg] = useState('');
  const { loginUser, isLoggedIn } = useAuth();
  const nav = useNavigate();

  const [notice, setNotice] = useState('');

  useEffect(() => {
    if (isLoggedIn) nav('/dashboard');
    // Check for session expired notice
    const msg = sessionStorage.getItem('login_notice');
    if (msg) { setNotice(msg); sessionStorage.removeItem('login_notice'); }
  }, [isLoggedIn]);

  const submit = async e => {
    e?.preventDefault();
    setError(''); setPendingMsg('');
    if (!id || !pw) { setError('Please enter your email/phone and password.'); return; }
    setLoading(true);
    try {
      const r = await authAPI.login({ identifier: id, password: pw });
      loginUser(r.data.token, r.data.user);
      toast.success('Welcome back! 🎉');
      nav('/dashboard');
    } catch (err) {
      const msg = err.response?.data?.message || '';
      if (msg === 'payment_required') nav(`/payment?user_id=${err.response.data.user_id}`);
      else if (msg?.toLowerCase().includes('pending')) setPendingMsg('Your account is pending admin approval. You will receive an email once approved.');
      else setError(msg || 'Invalid credentials. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', fontFamily:'var(--font-body)' }}>
      {/* Left panel */}
      <div style={{ width:'46%', background:'linear-gradient(145deg,#060f2e 0%,#0f2560 40%,#1A3C8F 75%,#2451b3 100%)', display:'flex', flexDirection:'column', justifyContent:'center', padding:'60px 52px', position:'relative', overflow:'hidden' }} className="hide-mobile">
        <div style={{ position:'absolute', width:520, height:520, background:'radial-gradient(circle,rgba(245,166,35,0.13),transparent 65%)', top:-130, right:-80, animation:'float 9s ease-in-out infinite', pointerEvents:'none' }} />
        <div style={{ position:'absolute', width:360, height:360, background:'radial-gradient(circle,rgba(100,150,255,0.08),transparent 65%)', bottom:-80, left:-60, animation:'float 12s ease-in-out infinite reverse', pointerEvents:'none' }} />
        <div style={{ position:'relative', animation:'fadeInUp 0.7s ease' }}>
          <Link to="/" style={{ display:'inline-flex', alignItems:'center', gap:10, marginBottom:52, textDecoration:'none' }}>
            <div style={{ width:42,height:42,background:'rgba(245,166,35,0.18)',border:'2px solid rgba(245,166,35,0.35)',borderRadius:11,display:'flex',alignItems:'center',justifyContent:'center',fontSize:20 }}>🏆</div>
            <span style={{ fontFamily:'var(--font-heading)', fontSize:22, fontWeight:700, color:'#fff' }}>TNPSC <span style={{ color:'var(--gold)' }}>Hub</span></span>
          </Link>
          <h2 style={{ fontFamily:'var(--font-heading)', fontSize:36, fontWeight:800, color:'#fff', lineHeight:1.25, marginBottom:16 }}>
            Your Journey to a<br /><span style={{ color:'var(--gold)' }}>Government Job</span><br />Starts Here
          </h2>
          <p style={{ color:'rgba(255,255,255,0.5)', fontSize:15, lineHeight:1.75, marginBottom:40 }}>
            Practice with 15,000+ curated TNPSC questions and real exam-pattern mock tests.
          </p>
          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {['📚 15,000+ Curated Questions','⏱️ Real Exam Mock Tests (3 hrs)','📅 Week-by-Week Test Unlock','📊 Detailed Performance Analytics','🎯 Daily Quiz — Free Forever'].map(f => (
              <div key={f} style={{ display:'flex', alignItems:'center', gap:12, padding:'11px 16px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.06)', borderRadius:10, color:'rgba(255,255,255,0.75)', fontSize:13 }}>
                {f}
              </div>
            ))}
          </div>
          <div style={{ marginTop:44, padding:'18px 20px', background:'rgba(245,166,35,0.1)', border:'1px solid rgba(245,166,35,0.25)', borderRadius:14 }}>
            <div style={{ fontSize:12, color:'rgba(255,255,255,0.4)', marginBottom:5, textTransform:'uppercase', letterSpacing:'0.8px' }}>One-Time Fee</div>
            <div style={{ display:'flex', alignItems:'baseline', gap:6 }}>
              <span style={{ fontFamily:'var(--font-heading)', fontSize:40, fontWeight:900, color:'var(--gold)', lineHeight:1 }}>₹499</span>
              <span style={{ color:'rgba(255,255,255,0.35)', fontSize:13 }}>· All groups · No renewal</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right panel */}
      <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', padding:'50px 5%', background:'var(--bg)', overflowY:'auto' }}>
        <div style={{ width:'100%', maxWidth:420, animation:'fadeInUp 0.55s ease' }}>
          {/* Mobile logo */}
          <div style={{ display:'none', justifyContent:'center', marginBottom:32 }} className="mobile-logo">
            <Link to="/" style={{ fontFamily:'var(--font-heading)', fontSize:26, fontWeight:700, color:'var(--blue)', textDecoration:'none' }}>TNPSC <span style={{ color:'var(--gold)' }}>Hub</span></Link>
          </div>

          <h1 style={{ fontFamily:'var(--font-heading)', fontSize:32, fontWeight:800, color:'var(--dark)', marginBottom:6 }}>Welcome back 👋</h1>
          <p style={{ color:'var(--muted)', fontSize:14, marginBottom:32 }}>
            New here? <Link to="/register" style={{ color:'var(--blue)', fontWeight:700 }}>Create an account →</Link>
          </p>

          {notice && (
        <div style={{ background:'rgba(245,166,35,0.1)', border:'1.5px solid rgba(245,166,35,0.4)', borderRadius:12, padding:'12px 16px', marginBottom:14, display:'flex', gap:10, alignItems:'flex-start' }}>
          <span style={{ fontSize:18, flexShrink:0 }}>📱</span>
          <div>
            <div style={{ fontWeight:700, fontSize:13, color:'#b37700', marginBottom:2 }}>Session Ended</div>
            <div style={{ fontSize:12, color:'#7a5200' }}>{notice}</div>
          </div>
        </div>
      )}
      {error && <Alert type="error" onClose={() => setError('')}>{error}</Alert>}
          {pendingMsg && <Alert type="warning">{pendingMsg}</Alert>}

          <form onSubmit={submit}>
            <div className="form-group">
              <label className="form-label">Email or Phone Number</label>
              <div className="input-wrap">
                <span className="input-icon">👤</span>
                <input className="form-input" placeholder="Enter email or 10-digit phone" value={id} onChange={e => setId(e.target.value)} autoComplete="username" />
              </div>
            </div>

            <div className="form-group">
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:7 }}>
                <label className="form-label" style={{ margin:0 }}>Password</label>
                <Link to="/forgot-password" style={{ fontSize:12, color:'var(--blue)', fontWeight:600 }}>Forgot password?</Link>
              </div>
              <div className="input-wrap">
                <span className="input-icon">🔒</span>
                <input type={showPw ? 'text' : 'password'} className="form-input" placeholder="Enter your password" value={pw} onChange={e => setPw(e.target.value)} style={{ paddingRight:44 }} autoComplete="current-password" />
                <button type="button" onClick={() => setShowPw(s=>!s)} style={{ position:'absolute',right:13,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',fontSize:16,color:'#bbb',padding:2,lineHeight:1 }}>{showPw ? '🙈' : '👁️'}</button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-lg btn-full" style={{ marginTop:4 }} disabled={loading}>
              {loading ? <><Spinner size={17} color="white" /> Signing in...</> : '→ Login to Dashboard'}
            </button>
          </form>

          <div style={{ display:'flex', alignItems:'center', gap:12, margin:'24px 0' }}>
            <div style={{ flex:1, height:1, background:'var(--border)' }} />
            <span style={{ fontSize:12, color:'var(--muted)' }}>or</span>
            <div style={{ flex:1, height:1, background:'var(--border)' }} />
          </div>

          <Link to="/register" className="btn btn-outline btn-lg btn-full">✍️ Create New Account</Link>

          <div style={{ marginTop:24, padding:'14px 18px', background:'rgba(26,60,143,0.04)', borderRadius:12, border:'1px solid var(--border)', textAlign:'center' }}>
            <div style={{ fontSize:11, color:'var(--muted)', marginBottom:5, textTransform:'uppercase', letterSpacing:'0.7px' }}>Admin Access</div>
            <Link to="/admin/login" style={{ color:'var(--blue)', fontSize:13, fontWeight:700 }}>Admin Panel Login →</Link>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-14px)}}
        @media(max-width:768px){.hide-mobile{display:none!important}.mobile-logo{display:flex!important}}
      `}</style>
    </div>
  );
}
